import BaseService from '../BaseService.js'

export default class KontaktinformationService extends BaseService {
  constructor() {
    super('public/kontaktinformation')
  }

  async findByKanton(kanton, meldeverfahren = 0) {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}/${encodeURIComponent(kanton)}?meldeverfahren=${meldeverfahren}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async findByGav(contractNumber) {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}/gav/${encodeURIComponent(contractNumber)}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }
}
